import { render } from "./DataTableLoader.vue?vue&type=template&id=5857a472&scoped=true"
import script from "./DataTableLoader.vue?vue&type=script&lang=js"
export * from "./DataTableLoader.vue?vue&type=script&lang=js"

import "./DataTableLoader.vue?vue&type=style&index=0&id=5857a472&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5857a472"]])

export default __exports__